<div class="job-container">
  <app-job-option-list
    [widgetId]="dataGroupItemInstance.children[0].widgetId"
    [dataGroupItem]="dataGroupItemInstance.children[0]"
    [dataGroup]="dataGroupItemInstance"
    (hasData)="onHasData($event, dataGroupItemInstance.children[0])"/>
</div>
